/*
 * Title: LinkTo/index.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: Global Link navigation between the screens.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import { Link } from "react-router-dom";

type Props = {
  className: string;
  text: string;
  to: string;
  rel?: string;
  prefix?: object;
  suffix?: object;
  link?: boolean;
};

const LinkTo: React.FC<Props> = (props) => {
  const { className, prefix, text, to, suffix, rel } = props;
  return (
    <Link to={to} className={className} rel={rel}>
      <>
        {prefix}
        {text}
        {suffix}
      </>
    </Link>
  );
};
export default LinkTo;
